import { Injectable } from '@angular/core';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CoaDiagnosticFixService {

  constructor(
    private jsonObjectFactory: JsonObjectFactoryService,
  ) {}

  getTaxYearDropDown(baseUrl: string, params: any, headerData: any): Observable<any> {
    return this.jsonObjectFactory.getJSONObj(baseUrl + '/loadJsonObject', params, headerData);
  }

  getScenarioDropDown(baseUrl: string, params: any, headerData: any): Observable<any> {
    return this.jsonObjectFactory.getJSONObj(baseUrl + '/loadJsonObject', params, headerData);
  }

  getCOAData(baseUrl: string, params: any, headerData: any): Observable<any> {
    return this.jsonObjectFactory.getJSONObj(baseUrl + '/loadJsonObject', params, headerData);
  }

  checkLockStatus(baseUrl: string, params: any, headerData: any): Observable<any> {
    return this.jsonObjectFactory.getJSONObj(baseUrl + '/loadJsonObject', params, headerData);
  }

  fixCoaMapping(baseUrl: string, params: any, headerData: any): Observable<any> {
    return this.jsonObjectFactory.saveJSON(baseUrl + '/saveJsonObject', params, headerData);
  }
}
